import React, { useCallback, useEffect } from "react";
import { Backdrop, makeStyles, Slide } from "@material-ui/core";
export const FTLHiddenMenu = ({ children, toolbar, open = false, onClose, height = "calc(100vh - 56px)", SlideProps, BackdropProps, }) => {
    var _a;
    const classes = useStyles({ height });
    const escHandler = useCallback((e) => e.code === "Escape" && onClose && onClose("escapeKeyDown"), []);
    useEffect(() => {
        document.addEventListener("keydown", escHandler, false);
        return () => document.removeEventListener("keydown", escHandler, false);
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Backdrop, Object.assign({}, BackdropProps, { open: open, onClick: (e) => e.button === 0 && onClose && onClose("backdropClick"), className: (_a = classes.backdrop + " " + (BackdropProps === null || BackdropProps === void 0 ? void 0 : BackdropProps.className)) !== null && _a !== void 0 ? _a : "" })),
        React.createElement(Slide, Object.assign({ direction: "left", in: open, mountOnEnter: true, unmountOnExit: true }, SlideProps),
            React.createElement("div", { className: classes.paper },
                React.createElement("div", { className: classes.scrollableDiv }, children),
                toolbar && React.createElement("div", { className: classes.toolbar }, toolbar)))));
};
const useStyles = makeStyles({
    backdrop: {
        zIndex: 1303,
        width: "100%",
        height: "100%",
    },
    paper: ({ height }) => ({
        display: "flex",
        position: "absolute",
        zIndex: 1304,
        flexDirection: "column",
        backgroundColor: "white",
        width: 544,
        height,
        bottom: 0,
        top: "auto",
        right: 0,
        margin: `0px !important`,
    }),
    scrollableDiv: {
        height: `100%`,
        overflow: "auto",
        padding: "24px 22px 18px 26px",
    },
    toolbar: {
        padding: "18px 22px 18px 26px",
    },
});
//# sourceMappingURL=index.js.map